
// ページ内アンカーリンクのスクロールエフェクト
// ヘッダーが固定の場合はheaderHightにヘッダーの高さを設定(PC/SP要設定)
jQuery(function ($) {
	var headerHight = 0; // 固定ヘッダの高さ
	$('a[href^="#"]').click(function () {
		var href = $(this).attr("href");
		var target = $(href == "#" || href == "" ? 'html' : href);
		if (target.length > 0) {
			var position = target.offset().top - headerHight;
			$("html, body").animate({ scrollTop: position }, 550, "swing");
			return false;
		}
	});
})

// ブログサムネイル 中心でトリミング
// jQuery(function($) {
//     if ( $('.obj_image').length > 0 ) {
//         objectFitImages('.obj_image');
//     }
// });


// ページトップボタンの表示
jQuery(function ($) {
	// 該当なしでも
	if ($('#pageup').length > 0) {
		var topBtn = $('#pageup');
		topBtn.css("display", "none");
		//スクロールが100に達したらボタン表示
		$(window).scroll(function () {
			if ($(this).scrollTop() > 100) {
				topBtn.fadeIn();
			} else {
				topBtn.fadeOut();
			}
		});
		//スクロールしてトップ
		topBtn.click(function () {
			$('body,html').animate({
				scrollTop: 0
			}, 500);
			return false;
		});
	}
});



// アコーディオンの起動
jQuery(function ($) {

	function toggleAccordion() {
		if (window.innerWidth <= 768) { // 768px以下の場合
			if ($('.accordion_title').length > 0) {
				$(".accordion_title").off("click").on("click", function () { // イベントの重複を防ぐためにoff()を使用
					$(this).next(".accordion_content").slideToggle();
					$(this).toggleClass("open");
				});
			}
		} else {
			$(".accordion_title").off("click"); // 768px以上の場合はクリックイベントを解除
			$(".accordion_content").removeAttr("style"); // スタイルを初期化（slideToggleで設定されたスタイルを解除）
			$(".accordion_title").removeClass("open"); // クラスもリセット
		}
	}

	toggleAccordion(); // ページロード時に適用

	$(window).on('resize', function () {
		toggleAccordion(); // ウィンドウサイズ変更時に適用
	});
});



// ドロワーメニュー
jQuery(function ($) {
	if ($('#toggle').length > 0) {
		$('#toggle').click(function () {
			$(this).toggleClass('toggle_active');
			$('#drawer_layer').fadeToggle();
			$('body').toggleClass('drawer_open');
			$('nav').toggleClass('is_open');

			if ($(this).hasClass('toggle_active')) {
				$('nav').removeClass('is_close');
			} else {
				$('nav').addClass('is_close');
			}
		});

		$('#drawer_layer').click(function () {
			$(this).fadeOut();
			$('#toggle').removeClass('toggle_active');
			$('body').removeClass('drawer_open');
			$('nav').removeClass('is_open');
			$('nav').addClass('is_close');
		});

		// エリア内リンク用
		$('nav a').on('click', function () {
			if (window.innerWidth <= 768) {
				$('#toggle').click();
			}
		});
	}

});

// 鳥＆UFO通過エフェクト（TOPのKV）
jQuery(function ($) {
	if ($('#bird').length > 0 && $('#ufo').length > 0) {
		var ww = Math.floor($(window).width());
		var TIME_DELAY_INIT = 8000;
		var TIME_DURATION_BIRD = ww > 768 ? 5000 : 3000;
		var TIME_INTERVAL = 8000;
		var TIME_DURATION_UFO = ww > 768 ? 10000 : 8000;
		var CLASS_PASSING = "passing";
		var $bird = $('#bird');
		var $ufo = $('#ufo');


		function seaquence() {

			addClassAcync($bird, CLASS_PASSING, TIME_DURATION_BIRD, TIME_DELAY_INIT)
				.then(function () { return removeClassAcync($bird, CLASS_PASSING, 0, 0); })
				.then(function () { return addClassAcync($ufo, CLASS_PASSING, TIME_DURATION_UFO, TIME_INTERVAL); })
				.then(function () { return removeClassAcync($ufo, CLASS_PASSING, 0, 0); })
				.then(function () { seaquence(); });
		}

		// 実行
		seaquence();

	}

	/**
		 * 要素にクラスを付加＆エフェクト時間後にresolveするpromiseを返す
		 * @param {Object} $elm
		 * @param {String} className
		 * @param {number} duration
		 * @returns
		 */
	function addClassAcync($elm, className, duration, delay) {
		var def = new jQuery.Deferred;
		setTimeout(function () {
			$elm.addClass(className);
			if (duration !== 0) {
				setTimeout(function () {
					def.resolve();
				}, duration);
			} else {
				def.resolve();
			}
		}, delay);

		return def.promise();
	}


	/**
	 * 要素からクラスを除去＆エフェクト時間後にresolveするpromiseを返す
	 * @param {Object} $elm
	 * @param {String} className
	 * @param {number} duration
	 * @returns
	 */
	function removeClassAcync($elm, className, duration, delay) {
		var def = new jQuery.Deferred;
		setTimeout(function () {
			$elm.removeClass(className);
			if (duration !== 0) {
				setTimeout(function () {
					def.resolve();
				}, duration);
			} else {
				def.resolve();
			}
		}, delay);

		return def.promise();
	}

});

// モグラエフェクト
jQuery(function ($) {
	if ($('#mogura_effect').length > 0) {
		var $mogura = $('#mogura_effect');
		var $imgs = $('#mogura_effect img');
		var interval = 40;
		var CLASS_CURRENT = 'current';
		var CLASS_LOCK = 'lock';

		$mogura.on("click", function () {
			if (!$mogura.hasClass(CLASS_LOCK)) {
				hideMogura();
			}

		});


		function hideMogura(index) {
			index = index ? index : 0;
			if (index <= $imgs.length - 1) {

				setTimeout(function () {
					$imgs.removeClass(CLASS_CURRENT);
					$imgs.eq(index).addClass(CLASS_CURRENT);
					hideMogura(index + 1);
				}, interval);

			} else {
				$mogura.addClass(CLASS_LOCK);
				setTimeout(function () {
					appearMogura();
				}, 5000);
			}
		}

		function appearMogura(index) {
			index = index || index == 0 ? index : $imgs.length - 1;
			
			if (index >= 0) {

				setTimeout(function () {
					$imgs.removeClass(CLASS_CURRENT);
					$imgs.eq(index).addClass(CLASS_CURRENT);
					appearMogura(index - 1);
				}, interval);

			} else {
				$mogura.removeClass(CLASS_LOCK);
			}
		}
	}
});


// マウスカーソル
// jQuery(function ($) {

// 	//カーソル要素の指定
// 	var cursor = $("#cursor");
// 	//ちょっと遅れてついてくるストーカー要素の指定
// 	var stalker = $("#stalker");

// 	//mousemoveイベントでカーソル要素を移動させる
// 	$(document).on("mousemove", function (e) {
// 		//カーソルの座標位置を取得
// 		var x = e.clientX;
// 		var y = e.clientY;
// 		//カーソル要素のcssを書き換える用
// 		cursor.css({
// 			"opacity": "0.9",
// 			"top": y + "px",
// 			"left": x + "px"
// 		});
// 		//ストーカー要素のcssを書き換える用
// 		setTimeout(function () {
// 			stalker.css({
// 				"opacity": "0.6",
// 				"top": y + "px",
// 				"left": x + "px"
// 			});
// 		}, 140);//カーソルより遅れる時間を指定
// 	});

// 	//aタグホバー
// 	$("a,.toggle_button,.mogura_bo,.cursor_pointer,.--cursorPointer").on({
// 		"mouseenter": function () {
// 			//activeクラス付与
// 			cursor.addClass("active");
// 			stalker.addClass("active");
// 		},
// 		"mouseleave": function () {
// 			cursor.removeClass("active");
// 			stalker.removeClass("active");

// 		}
// 	});
// });

document.addEventListener('DOMContentLoaded', function (event) {

	// KVスライダー TOP
	if (document.querySelector('.js-frontKvSlider')) {
		const slider = new Swiper('.js-frontKvSlider', {
			autoplay: {
				delay: 5000,    // スライド表示時間
				disableOnInteraction: false,
			},
			loop: true,	// ループ表示
			loopAdditionalSlides: 1,    // ループ時に作成されるクローンの数を指定
			speed: 500,    // スライド変化時間
			navigation: {	// 前後ナビゲーション
				nextEl: '.js-frontKvSlider-next',
				prevEl: '.js-frontKvSlider-prev',
			},
			pagination: {
				el: '.js-frontKvSlider-dots',
				type: 'bullets',
				clickable: true,
			}
		})
	}

	// KVスライダーのリンク対応
	if (document.querySelector('.js-slider-link .js-slider-link-button')) {
		const button = document.querySelector('.js-slider-link .js-slider-link-button');
		button.addEventListener('click', function(e) {
			e.preventDefault();
			e.stopPropagation();
			const elements = document.elementsFromPoint(e.clientX, e.clientY)

			const elm = elements.filter(element => {
				return element.classList.contains('js-slider-link-origin')
			});
			if (elm.length > 0 && elm[0].href && elm[0].getAttribute('href') !== '') {
				
				if (elm[0].target == '_blank') {
					window.open(elm[0].href);
				} else {
					location.href = elm[0].href;
				}
				
			}
			
		}, false);
		button.classList.add('set-link');
	}

	// モーダル
	if (document.querySelector('.micromodal')) {

		MicroModal.init({
			awaitOpenAnimation: false,	// モーダルオープン時にアニメーションを許可
			awaitCloseAnimation: false,	// モーダルクローズ時にアニメーションを許可
			disableScroll: true,			// bodyのスクロールを禁止
			disableFocus: true,
		});
		
		// 【micromodal共通】モーダル自身のクリック伝番禁止
		if (document.querySelector('.modal__container')) {
			document.querySelectorAll('.modal__container').forEach(modal => {
				// マウス用の伝搬禁止
				modal.addEventListener('click', function(e) {
					e.stopPropagation();
				});
				// タッチ用の伝搬禁止
				modal.addEventListener('touchstart', function(e) {
					e.stopPropagation();
				});

				// 閉じるボタン
				modal.querySelectorAll('[data-micromodal-close]').forEach(close => {
					close.addEventListener('click', closeElmInModal, false);
					close.addEventListener('touchstart', closeElmInModal, false);
				})


				function closeElmInModal(e) {
					e.preventDefault();
						e.stopPropagation();
						const wrapper = e.target.closest('.micromodal');
						if (wrapper && wrapper.id) {
							MicroModal.close(wrapper.id);
						}
				}
			});
		}


		// URLパラメータ modal_post_id で指定されたidのモーダルを初期状態で表示する
		// const url = new URL(location.href);
		const params = getUrlParameters();
		if (params.modal_post_id && document.querySelector(`#modal_${params.modal_post_id}.micromodal`)) {
			MicroModal.show(`modal_${params.modal_post_id}`, { disableFocus: true });
		}

	}

	// コピー
	if (document.querySelector('.js-copy')) {
		document.querySelectorAll('.js-copy').forEach(button => {
			if (button.dataset.copy) {
				button.addEventListener('click', function (e) {
					e.preventDefault();
					e.stopPropagation();
					const target = e.target.closest('.js-copy');
					const copyText = target.dataset.copy;
					copyToClipboard(target, copyText);
				}, false);
			}
		});

		/**
		 * クリップボードコピー
		 * @param {Element} button - コピーボタン
		 * @param {String} copyText - クリップボードにコピーするテキスト
		 * @returns 
		 */
		function copyToClipboard(button, copyText) {
			if (navigator.clipboard) { // navigator.clipboardが使えるか判定する
				return navigator.clipboard.writeText(copyText).then(function () { // クリップボードへ書きむ
					messageActive();
				})
			} else {
				messageError();
			}

			function messageActive() {
				button.classList.add('--done');
				setTimeout(function () {
					button.classList.remove('--done');
				}, 3000);
			}
			function messageError() {
				button.classList.add('--error');
				setTimeout(function () {
					button.classList.remove('--error');
				}, 3000);
			}
		}

	}


	// スライダー（モーダル内サムネイル）
	if (document.querySelector('.slider_thumbnail_parent .slider_thumbnail')) {

		document.querySelectorAll('.slider_thumbnail_parent .slider_thumbnail').forEach(elm => {
			const parent = elm.closest('.slider_thumbnail_parent');
			if (parent.querySelectorAll('.swiper-slide').length > 1) {
				new Swiper(elm, {
					autoplay: {
						delay: 5000,    // スライド表示時間
					},
					loop: true,	// ループ表示
					loopAdditionalSlides: 1,    // ループ時に作成されるクローンの数を指定
					speed: 500,    // スライド変化時間
					navigation: {	// 前後ナビゲーション
						nextEl: parent.querySelector('.swiper-button-next'),
						prevEl: parent.querySelector('.swiper-button-prev'),
					},
				});

			} else {
				parent.querySelector('.swiper-button-next').style.display = 'none';
				parent.querySelector('.swiper-button-prev').style.display = 'none';
			}
		});

	}

	// TOPのお問い合わせ
	if (document.querySelector('#contact_section #contact_button')) {
		const section = document.getElementById('contact_section');
		document.getElementById('contact_button').addEventListener('click', function (e) {
			e.preventDefault();
			e.stopPropagation();
			// const button = e.target.closest('#contact_button');
			// button.classList.add('--open');

			const scroll = window.scrollY;
			const position = Math.floor(section.getBoundingClientRect().top + scroll);
			const wh = window.innerHeight;
			if (position + wh / 3 < scroll || position > scroll + wh / 3) {
				window.scrollTo({
					top: position,
					behavior: 'smooth'
				})
			}

			MicroModal.show('modal_contact');
			document.querySelector('#modal_contact .privacy_scroll_box').scrollTo({
				top: 0
			})

		}, false);
	}

	// TOPのX埋め込みの遷移設定
	// if (document.getElementById('js-twitter-link')) {
	// 	document.getElementById('js-twitter-link').addEventListener('click', function(e) {
	// 		e.preventDefault();
	// 		e.stopPropagation();
	// 		window.open('https://x.com/PRnishimurayuji');
	// 		return false;
	// 	}, false);
	// }

	// TOPスライダー
	if (document.querySelector('.js-gif-anim-target[data-gif-anim-id]') && document.querySelector('.js-gif-anim-trigger[data-gif-anim-id]')) {
		const isTouch = 'ontouchend' in document;
			
		document.querySelectorAll('.js-gif-anim-target[data-gif-anim-id]').forEach(imgElm => {
			try {

				const gifAnimId = imgElm.dataset.gifAnimId;
				if (!gifAnimId) {
					throw new Error('data-gif-anim-id属性が取得できません');
				}

				const trigger = document.querySelector(`.js-gif-anim-trigger[data-gif-anim-id="${gifAnimId}"]`);

				// if (imgElm.dataset.gifAnimId.length > 0 && trigger) {
				// 	if (imgElm.dataset.gifAnimSrc.length > 0) {
				// 		imgElm.dataset.gifAnimStaticSrc = imgElm.src;
				// 	}
				// }
				if (imgElm.dataset.gifAnimSrc && imgElm.dataset.gifAnimSrc.length > 0 && imgElm.dataset.gifAnimId.length > 0 && trigger) {
					imgElm.dataset.gifAnimStaticSrc = imgElm.src;
				}

				if (isTouch) {	// タッチの場合
					trigger.addEventListener('click', listenerToggle, false);
				} else {	// マウスの場合
					trigger.addEventListener('mouseenter', listenerEnter, false);
					trigger.addEventListener('mouseleave', listenerLeave, false);

				}
			} catch(err) {
				console.error(err);
			}

		})


		// SPのタッチリスナー
		function listenerToggle(e) {
			e.preventDefault();
			e.stopPropagation();
			
			try {
				
				const gifAnimId = e.target.dataset.gifAnimId;
				if (!gifAnimId) {
					throw new Error('data-gif-anim-id属性が取得できません');
				}

				const imgElm = document.querySelector(`.js-gif-anim-target[data-gif-anim-id="${gifAnimId}"]`);
				if (!imgElm) {
					throw new Error('対応する画像要素がありません');
				}
				switchImage(imgElm, !imgElm.classList.contains('is-moving'));
			} catch(err) {
				console.error(err);
			}

		}
		// PCのマウスエンターリスナー
		function listenerEnter(e) {
			e.preventDefault();
			e.stopPropagation();
			
			try {
				
				const gifAnimId = e.target.dataset.gifAnimId;
				if (!gifAnimId) {
					throw new Error('data-gif-anim-id属性が取得できません');
				}

				const imgElm = document.querySelector(`.js-gif-anim-target[data-gif-anim-id="${gifAnimId}"]`);
				if (!imgElm) {
					throw new Error('対応する画像要素がありません');
				}
				if (!imgElm.classList.contains('is-moving')) {
					switchImage(imgElm, true);
				}
				
			} catch(err) {
				console.error(err);
			}
		}
		// PCのマウスリーブリスナー
		function listenerLeave(e) {
			e.preventDefault();
			e.stopPropagation();
			
			try {
				
				const gifAnimId = e.target.dataset.gifAnimId;
				if (!gifAnimId) {
					throw new Error('data-gif-anim-id属性が取得できません');
				}

				const imgElm = document.querySelector(`.js-gif-anim-target[data-gif-anim-id="${gifAnimId}"]`);
				if (!imgElm) {
					throw new Error('対応する画像要素がありません');
				}
				if (imgElm.classList.contains('is-moving')) {
					switchImage(imgElm, false);
				}
				
			} catch(err) {
				console.error(err);
			}
		}
		// gifアニメとサムネイルの切替
		function switchImage(imgElm, isAnimStart) {
			if (isAnimStart) {
				let hasGif = true;
				if (imgElm.dataset.gifAnimSrc) {
					imgElm.src = imgElm.dataset.gifAnimSrc;
				} else {
					hasGif = false;
				}
				
				imgElm.classList.add('is-moving');
				const gifAnimTime = imgElm.dataset.gifAnimTime;
				if ((isTouch || !hasGif) && gifAnimTime && !isNaN(Number(gifAnimTime))) {
					setTimeout(function() {switchImage(imgElm, 0)}, Number(gifAnimTime));
				}
			} else {
				if (imgElm.dataset.gifAnimStaticSrc) {
					imgElm.src = imgElm.dataset.gifAnimStaticSrc;
					imgElm.classList.remove('is-moving');
				} else if (isAnimStart === 0) {
					imgElm.classList.remove('is-moving');
				}
			}
		}

	}

	// マンガモーダル
	const mangaBaseOptions = {
		speed: 500,    // スライド変化時間
		pagination: {
			type: 'custom',                // タイプを 'custom' に設定
		},
	};
	const renderCustom = function (swiper, current, total) {
			// current: 現在のスライド番号 (1から始まる)
			// total: スライドの総数
			
			// 「1 / 3」の形式で文字列を返す
			return current + ' / ' + total;
		};

	// まんがモーダル内のスライダーオブジェクト
	let mangaSwiper;

	if (document.querySelector('.modal_manga .js-manga-slider') && document.querySelector('.js-manga-modal-trigger')) {
		try {
			const modal = document.getElementById('manga_modal');
			if (!modal) {
				throw new Error('まんがモーダルがありません');
			}
			const slider = modal.querySelector('.js-manga-slider');
			const sliderWrapper = slider.querySelector('.swiper-wrapper');
			const titleElm = modal.querySelector('.js-manga-title');
			const dateElm = modal.querySelector('.js-manga-date');
			const catWrapper = modal.querySelector('.js-manga-catWrap');
			const othersWrapper = modal.querySelector('.js-manga-othersWrap');
			const copy = modal.querySelector('.js-copy');
			if (!slider || !sliderWrapper || !titleElm || !dateElm || !catWrapper) {
				throw new Error('まんがモーダル内の要素が足りません');
			}

			// swiperのオプション
			const cloneOptions = JSON.parse(JSON.stringify(mangaBaseOptions));
			cloneOptions.navigation = {
				nextEl: modal.querySelector('.js-manga-slider-next'),
				prevEl: modal.querySelector('.js-manga-slider-prev'),
			}
			cloneOptions.pagination.el = modal.querySelector('.js-manga-slider-nav');
			cloneOptions.pagination.renderCustom = renderCustom;

			document.querySelectorAll('.js-manga-modal-trigger').forEach(trigger => {
				trigger.addEventListener('click', function(e) {
					e.preventDefault();
					e.stopPropagation();

					const button = e.target.closest('.js-manga-modal-trigger');

					// 画像取得	data-manga-src
					const images = button.dataset.mangaSrc ? button.dataset.mangaSrc.split(',') : null;
					// id取得 data-post-id
					const id = button.dataset.postId ? button.dataset.postId : null;
					// タイトル取得 js-manga-src-title
					const title = button.querySelector('.js-manga-src-title') ? button.querySelector('.js-manga-src-title').innerText : '';
					// 日付取得 js-manga-src-date
					const date = button.querySelector('.js-manga-src-date') ? button.querySelector('.js-manga-src-date').innerText : '';
					// カテゴリー取得 js-manga-src-cat
					const cat = button.querySelector('.js-manga-src-cat') ? button.querySelector('.js-manga-src-cat').innerText : '';
					// キャラクターなどその他情報の取得 js-manga-src-others
					const others = button.querySelector('.js-manga-src-others') && button.querySelector('.js-manga-src-others').innerText.length > 0 ? button.querySelector('.js-manga-src-others').innerText.split(',') : [];
					// copy用の現在のURL
					const currentURL = copy.dataset.currentUrl ? copy.dataset.currentUrl : null;

					// スライダー
					if (images) {
						const html = images.map(image => `<div class="modal_manga_slider_slide swiper-slide"><img src="${image}"></div>`).join('');
						sliderWrapper.innerHTML = html;
						if (images.length > 0) {
							if (mangaSwiper) {
								mangaSwiper.destroy();
								mangaSwiper = null;
							}
							mangaSwiper = new Swiper(slider, cloneOptions);
						}
					} else {
						sliderWrapper.innerHTML = `<div class="modal_manga_slider_slide swiper-slide"><img src="/assets/img/manga/nomanga.webp"></div>`;
					}

					// タイトル
					titleElm.innerText = title ? title : 'タイトル未設定';

					// 日付
					dateElm.innerText = date ? date : '公開日未設定';

					// カテゴリー
					catWrapper.innerHTML = cat ? `<li><span>${cat}</span></li>` : '';

					// その他
					if (othersWrapper) {
						let othersHTML = '';
						for(let other of others) {
							othersHTML += `<li><span>${other}</span></li>`;
						}
						othersWrapper.innerHTML = othersHTML;
					}
					

					// URLコピー
					copy.dataset.copy = currentURL && id ? `${currentURL}?post_id=${id}` : '';

					MicroModal.show(modal, { disableFocus: true });

				}, false)
			})
		} catch(err) {
			console.error(err);
		}
		
	}

	// GETパラメータでpost_id指定で遷移してきた場合
	if (document.querySelector('.has-get-param .modal_manga .js-manga-slider')) {
		try {

			const wrapper = document.querySelector('.has-get-param .modal_manga');
			const slider = wrapper.querySelector('.js-manga-slider');

			if (!wrapper || !slider) {
				throw new Error('GETパラメータ指定の投稿のモーダルがありません');
			}
			
			// swiperのオプション
			const cloneOptions = JSON.parse(JSON.stringify(mangaBaseOptions));
			cloneOptions.navigation = {
				nextEl: wrapper.querySelector('.js-manga-slider-next'),
				prevEl: wrapper.querySelector('.js-manga-slider-prev'),
			}
			cloneOptions.pagination.el = wrapper.querySelector('.js-manga-slider-nav');
			cloneOptions.pagination.renderCustom = renderCustom;

			new Swiper(slider, cloneOptions);

		} catch(err) {
			console.error(err);
		}
	}

	// タブ切り替え（みんなの自己紹介）
	if (document.querySelector('.js-tab-switch')) {
        
		document.addEventListener('click', switchTab, false);
		
		function switchTab(e) {
			if (e.target.classList.contains('js-tab-switch__trigger')) {
				e.preventDefault();
				e.stopPropagation();
				
				const target = e.target;
				const wrapper = target.closest('.js-tab-switch');
				const index = target.dataset.tabId;
				wrapper.querySelectorAll('.js-tab-switch__trigger').forEach(btn => {
					if (target == btn) {
						if (!btn.classList.contains('is-current')) {
							btn.classList.add('is-current');
						}

					} else {
						if (btn.classList.contains('is-current')) {
							btn.classList.remove('is-current');
						}
					}
				});
				wrapper.querySelectorAll('.js-tab-switch__target').forEach(content => {
				if (content.dataset.tabId == index) {
					if (!content.classList.contains('is-current')) {
						content.classList.add('is-current');
					}
				} else {
					if (content.classList.contains('is-current')) {
						content.classList.remove('is-current');
					}
				}

			});            
			}
		}
	}

});

/**
 * URLパラメータを取得
 * @returns Object - URLパラメータをkey:valueで格納
 */
function getUrlParameters() {
	const params = new URL(window.location.href).searchParams;
	const obj = {};
	params.forEach((value, key) => {
		obj[key] = value;
	})
	return obj;
}
